'use client'

import { UndertakingsTableModule } from '@repo/undertakings/UndertakingsTableModule'

const UndertakingsTable = () => {
  return <UndertakingsTableModule />
}

export default UndertakingsTable
